// src/Api/PriceLists.js
import api from './Axios';

export async function fetchPricesForProducts(priceListId, productIds) {
    const params = new URLSearchParams();
    productIds.forEach(id => params.append('product_ids[]', id));

    const response = await api.get(`/price_lists/${priceListId}/prices`, {
        params,
    });

    return response.data;
}
